export const hintsPt = {
  listPageSubtitle:
    "Crie o formulário aqui. Depois abra Editar para definir secções e perguntas na pré-visualização.",
  listEmptyForms: "Comece por criar um formulário no painel à esquerda.",
  formCode:
    "Identificador único (ex.: PESQ_2026). Aparece em listagens e relatórios.",
  formTargetGroup: "Quem irá responder: graduados ou empregadores.",
  formActive: "Formulários inactivos podem deixar de estar disponíveis para preenchimento no portal.",

  editPageSubtitle:
    "1. Dados do formulário → 2. Secções (à esquerda) → 3. Clique numa pergunta na pré-visualização para editar.",
  editFlowCallout:
    "Crie secções à esquerda. Na pré-visualização, clique numa pergunta para a editar ou use Adicionar pergunta no fim de cada bloco.",
  formCodeEdit: "Código único do formulário. Evite alterá-lo se já existirem respostas.",
  formActiveEdit: "Desactivar impede novos preenchimentos, conforme as regras do portal.",

  sectionsIntro:
    "Organize o inquérito em secções. As perguntas associam-se a uma secção na pré-visualização.",
  sectionParent: "Deixe (Topo) para secção de primeiro nível; escolha uma secção pai para criar uma subsecção.",

  previewIntro:
    "Clique numa pergunta para editar o texto, o tipo e as opções. As alterações guardam-se ao sair do campo.",

  questionTypeRadio: "Escolha única: o respondente marca apenas uma opção.",
  questionTypeCheckbox: "Escolha múltipla: o respondente pode marcar várias opções.",

  optionsDraftLabel: "Opções (separe com ; ou cole uma lista)",
  optionsDraftPlaceholder: "Laboral; Pós‑Laboral; Sim, mas tenho",
  optionsDraftHelp:
    "Use ; ou Enter para confirmar. Vírgulas fazem parte do texto da opção. Ao colar do Excel ou do Notepad, cada linha vira uma opção.",
  optionsSavedHelp:
    "Uma opção de cada vez. Pode usar vírgulas no texto (ex.: Sim, mas tenho).",

  conditionsIntro:
    "Quando a condição for verdadeira, esta pergunta fica visível. A pergunta de referência deve ser anterior no formulário.",
  conditionsNumber:
    "Maior/menor só se aplica a perguntas numéricas. Se a pergunta ficar oculta, não é obrigatória responder.",
  conditionsEmpty: "Sem condições: a pergunta é sempre mostrada.",

  previewEmptyQuestions: "As perguntas aparecem aqui depois de as criar.",
};
